import { FormControlLabel, Switch, type SwitchProps } from '@mui/material';
import { memo, useCallback } from 'react';

import type { ControlProps } from './SettingControl';

type T = ControlProps<boolean>;
export interface BooleanControlProps
  extends T, Omit<SwitchProps, keyof T | 'onChange'> {
  type: 'boolean';
  onChange?: (value: boolean) => void;
}

export const BooleanControl = memo<Omit<BooleanControlProps, 'type'>>(
  ({ name, label, value, defaultValue, onChange, ...props }) => {
    const handleChange = useCallback(
      (event: React.ChangeEvent<HTMLInputElement>) => {
        onChange?.(event.target.checked);
      },
      [onChange],
    );

    return (
      <FormControlLabel
        control={
          <Switch
            checked={value}
            onChange={handleChange}
            defaultChecked={defaultValue}
            {...props}
          />
        }
        label={label || name}
      />
    );
  },
);

BooleanControl.displayName = 'BooleanControl';
